import { Router } from "@angular/router";

export const toollist =  [
    {
        "Type": "Button",
        "Label": "Nouvel objectif",
        "Color": "accent",
        "Icon": "add",
        "Method": "newObjectif",
        //"Condition": "hasUniqSelectedBuilding"
    },
    {
        "Type": "Button",
        "Label": "Mode d'emploi",
        "Color": "danger",
        "Icon": "help",
        "Method": "toggleManual"
    }
]